// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_sr-0";